// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__8dANP","networks":"Footer_networks__WiI6e","links":"Footer_links__Ujy1S","copyright":"Footer_copyright__DIN5n"};